import { IconButton as CarbonIconButton } from '@carbon/react';
import type { ComponentProps } from 'react';
import type { IconComponent } from '../../types';
import { cx } from '../../utils';
import styles from './CdIconButton.module.scss';

type CarbonIconButtonProps = ComponentProps<typeof CarbonIconButton>;

export interface CdIconButtonProps extends Omit<
  CarbonIconButtonProps,
  'children' | 'kind' | 'label'
> {
  /** Accessible name – also shown as tooltip. Required for icon-only controls. */
  label: string;
  icon: IconComponent;
  variant?: 'ghost' | 'primary' | 'secondary' | 'tertiary';
  /** Use on dark surfaces (e.g. navy side nav). */
  onDark?: boolean;
}

export const CdIconButton = ({
  label,
  icon: Icon,
  variant = 'ghost',
  onDark = false,
  className,
  ...rest
}: CdIconButtonProps) => {
  return (
    <CarbonIconButton
      label={label}
      kind={variant}
      className={cx(onDark && styles.onDark, className)}
      {...rest}
    >
      <Icon />
    </CarbonIconButton>
  );
};
